__webpack_require__.p = "/tokens-border-radius-improvements/system-email-templates/";